import React from 'react'
import Sketch from 'react-p5'

import Matter from "matter-js"

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

const extensions = require("./extensions")

let strings = new LocalizedStrings({
    en:{
        title:"eruption",
        eruptionChar:"o",
        description:""
    },
    de: {
        title:"eruption",
        eruptionChar:"ö",
        description:""
    }
});

class Eruption extends React.Component {
    constructor(props) {
        super(props)

        this.engine = null
        this.world = null
        this.fontSize = 10
        this.eruptionFontSize = 5
        this.columns = 10
        this.initSediment = true
        this.sedimentLines = 20
        this.eruptBodyies = []
        this.sedimentChar = "m"
        this.sedimentMass = 0.01
        this.eruptionForce = 0.00025

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    componentWillReceiveProps(props) {
        const { language } = this.props;

        if (props.language !== language) {
            strings.setLanguage(props.language)
            this.reset(this.p5)
        }
    }

    reset(p5) {
        this.engine = Matter.Engine.create();
        this.world = this.engine.world;

        this.world.gravity.scale = 0.001

        this.fontSize = Math.floor(window.innerHeight / 20)
        this.eruptionFontSize = this.fontSize/2
        this.columns = Math.floor(window.innerWidth / 80)

        p5.textFont("DejaVuSerif");
        p5.textSize(this.fontSize)

        Matter.World.add(this.world, extensions.makeWalls(p5, false, true, true, true))

        for (var i = 0; i < this.sedimentLines; i++) {
            Matter.World.add(this.world, this.line(p5, p5.random(0, Math.floor(p5.width/2)), p5.random(p5.height-Math.floor(p5.height/7), p5.height-Math.floor(p5.height / 7 * 5)), this.columns, this.sedimentChar))
        }
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)
        p5.background(0)

        this.reset(p5)
        this.p5 = p5
    }

    line(p5, x, y, columns, char) {
        var lineCharacters = []
        for (var c = 0; c < columns; c++) {
            var body = extensions.makePhysicsCharacter(p5, p5.random()*2+x+c*this.fontSize*0.9, y, char, this.fontSize, {mass: this.sedimentMass})

            lineCharacters.push(body)
        }

        return lineCharacters
    }

    erupt(p5) {
        var eruptBody = extensions.makePhysicsCharacter(p5, p5.width/2 + p5.random(-p5.width/40, p5.width/40), p5.height, strings.eruptionChar, this.eruptionFontSize)
        this.eruptBodyies.push(eruptBody)
        Matter.World.add(this.world, eruptBody)
    }

    draw(p5) {
        p5.background(0)
        if (this.world !== undefined) {
            if (this.initSediment) {
                for (var i = 0; i  < 200; i++) {
                    Matter.Engine.update(this.engine);
                }
                this.initSediment = false
            }
            else {
                Matter.Engine.update(this.engine);

            }

            if (p5.frameCount % 5 === 0) {
                this.erupt(p5)
            }

            var bodies = Matter.Composite.allBodies(this.engine.world);

            for (var j = 0; j < bodies.length; j += 1) {
                var body = bodies[j]

                if (body.label === strings.eruptionChar) {
                    Matter.Body.applyForce(body, {x: body.position.x, y: body.position.x}, {x: 0, y: -this.eruptionForce})
                }
                extensions.drawPhysicsCharacter(p5, body)
            }
        }
    }

    windowResized(p5) {
        p5.resizeCanvas(window.innerWidth, window.innerHeight)
        p5.background(0)

        this.reset(p5)
    }

    render() {
        strings.setLanguage(this.context.language)
        return <Sketch setup={this.setup} draw={this.draw} windowResized={this.windowResized} />
    }
}
Eruption.contextType = LanguageContext

export default Eruption
